<template>
  <div class="examination">
    <div
      class="tips"
      v-if="examinationPlan.state === '2' || examinationPlan.state === '3'"
    >
      {{ examinationPlan.examinationPrompt }}
    </div>
    <div
      class="tips2"
      v-if="examinationPlan.state === '2' || examinationPlan.state === '3'"
    >
      {{ examinationPlan.examinationPrompt }}
    </div>
    <div class="planTitle">
      {{ examinationPlan.examinationName }}
    </div>
    <div v-for="item in Questions" :key="item.id">
      <div class="box" v-if="item.questionsType === '1'">
        <div class="title">{{ item.serialNum }}、{{ item.questionsName }}</div>
        <van-radio-group v-model="item.answer" :disabled="readonly">
          <van-radio
            v-for="ele in item.choiceList"
            :key="ele.id"
            class="single"
            label-position="left"
            :name="ele.title"
            icon-size="20px"
            >{{ ele.title }}</van-radio
          >
        </van-radio-group>
      </div>
      <div class="box" v-if="item.questionsType === '2'">
        <div class="title">{{ item.serialNum }}、{{ item.questionsName }}</div>
        <van-checkbox-group v-model="item.answers" :disabled="readonly">
          <van-checkbox
            class="checkbox"
            :readonly="readonly"
            label-position="left"
            icon-size="20px"
            v-for="ele in item.choiceList"
            :key="ele.id"
            shape="square"
            :name="ele.title"
            >{{ ele.title }}</van-checkbox
          >
        </van-checkbox-group>
      </div>
      <div class="box" v-if="item.questionsType === '0'">
        <div class="title">{{ item.serialNum }}、{{ item.questionsName }}</div>
        <van-field
          rows="6"
          :readonly="readonly"
          v-model="item.answer"
          class="text"
          type="textarea"
          maxlength="2500"
          show-word-limit
          placeholder="最多填写2500个字"
        />
      </div>
    </div>
    <div class="btn_box">
      <van-button class="home" @click="goHome" type="primary">首页</van-button>
      <van-button
        v-if="examinationPlan.isState === '1'"
        class="punch"
        @click="submit"
        type="primary"
        >立即提交</van-button
      >
    </div>
  </div>
</template>
<script>
import {
  findExaminationAndQuestionsByExaminationId,
  findExaminationAndQuestionsByLearningId,
  submitExamination,
} from "@/common/api";
import watermark from "watermark-dom";
export default {
  data() {
    return {
      examinationPlan: {},
      Questions: [],
      readonly: false,
    };
  },
  async mounted() {
    const currentUser =
      JSON.parse(localStorage.getItem("currentUser")) || undefined;
    watermark.init({
      watermark_txt: currentUser.name,
      watermark_angle: 30,
    });
    let { id, type } = this.$route.params;
    if (type === "class") {
      let response = await findExaminationAndQuestionsByExaminationId({
        examinationId: id,
      });
      if (response.success) {
        this.examinationPlan = response?.data?.examinationPlan;
        this.Questions = response?.data?.Questions;
      }
    } else if (type === "item") {
      let response = await findExaminationAndQuestionsByLearningId({
        learningId: id,
      });
      if (response.success) {
        this.examinationPlan = response?.data?.examinationPlan;
        this.Questions = response?.data?.Questions;
      }
    } else if (type === "defails") {
      let response = await findExaminationAndQuestionsByExaminationId({
        examinationId: id,
      });
      if (response.success) {
        this.examinationPlan = response?.data?.examinationPlan;
        this.Questions = response?.data?.Questions;
      }
      // 只读模式
      this.readonly = true;
    }
  },
  methods: {
    // 返回首页
    goHome() {
      this.$router.replace("/");
    },
    // 提交考试
    async submit() {
      // 封装答案
      let params = [];
      this.Questions.forEach((element) => {
        let obj = {};
        if (element.questionsType === "2") {
          obj = {
            id: element.id,
            answer: element.answers.join(","),
          };
        } else {
          obj = {
            id: element.id,
            answer: element.answer,
          };
        }
        params.push(obj);
      });
      let response = await submitExamination({ answers: params });
      if (response.success) {
        this.goHome();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.examination {
  padding-bottom: 100px;
  .tips {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 1000;
    background: var(--theme-yellow-color);
    color: white;
    padding: 15px;
    font-size: 14px;
    box-sizing: border-box;
  }
  .tips2 {
    width: 100%;
    background: none;
    color: white;
    padding: 15px;
    font-size: 14px;
    box-sizing: border-box;
  }
  .planTitle {
    font-size: 14px;
    color: var(--theme-vice-font-color);
    padding: 15px;
  }
  .box {
    background: white;
    border-radius: 8px;
    margin: 10px 15px;
    padding: 10px;
    .title {
      font-size: 16px;
      font-weight: 600;
      margin: 10px 0;
    }
    .single {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0;
      border-bottom: 1px solid #f7f7f7;
    }
    .checkbox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0;
      border-bottom: 1px solid #f7f7f7;
    }
    .text {
      font-size: 14px;
      background: #f7f7f7;
      border-radius: 8px;
    }
  }
  .btn_box {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    z-index: 1000;
    display: flex;
    padding: 15px;
    background: #f5f5f5;
    .home {
      flex: 2;
      background: #b3b3b3;
      border-color: #b3b3b3;
      margin-right: 5px;
    }
    .pre {
      flex: 2;
      background: #b3b3b3;
      border-color: #b3b3b3;
      margin-right: 5px;
    }
    .next {
      flex: 2;
      background: #b3b3b3;
      border-color: #b3b3b3;
    }
    .punch {
      flex: 4;
      background: var(--van-primary-color);
      margin-left: 5px;
    }
    .examination {
      flex: 3;
      background: var(--van-primary-color);
      margin-left: 5px;
    }
  }
}
</style>
